module.exports = __webpack_public_path__ + "static/media/asics_landing_page.cd7e6c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/asics_landing_page.jpg
// module id = 766
// module chunks = 10